module.exports = __webpack_public_path__ + "img/1512666485.85920ad8.jpg";